module.exports = __webpack_public_path__ + "static/media/man5.909d804d.png";